import React, { useEffect } from "react";
import Hero from "../components/Hero";
import Badges from "../components/Badges";
import Specialties from "../components/Specialties";
import PainPoints from "../components/PainPoints";
import About from "../components/About";
import Reviews from "../components/Reviews";
import Process from "../components/Process";
import FAQ from "../components/FAQ";
import CTASection from "../components/CTASection";
import Zones from "../components/Zones";
import SEO from "../components/SEO";
import { PAGE_META } from "../data/pageMeta";

export default function Home() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SEO
        {...PAGE_META["/"]}
        keywords={["fasciathérapie Toulouse", "coach sportif domicile", "sport santé", "Tissual Balancing", "Saint-Orens", "Balma", "Quint-Fonsegrives"]}
      />
      <Hero />
      <Badges />
      <Specialties />
      <PainPoints />
      <About />
      <Zones />
      <Reviews />
      <Process />
      <FAQ />
      <CTASection />
    </>
  );
}
